// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1HBXR","header":"PatientQuestionnaire_header__2rAAr","info":"PatientQuestionnaire_info__1rgFk"};